import { useContext } from "react";
import { ErrorContext } from "./ErrorContextProvider";

export function useError() {
    return useContext(ErrorContext);
}